export default __webpack_public_path__ + "b078618b41b9b6629ea00ad839370cd6.ttf";